import { useEffect, useRef } from "react";
import Brand from "../Brand/Brand";
import styles from "./NavBar.module.css";
import { navLinks, useNavBarController } from "./NavBar.controller";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const NavBar = () => {
  const { menuOpen, toggleMenu, closeMenu } = useNavBarController();
  const initialOverflow = useRef<{
    body: string;
    html: string;
  }>({ body: "", html: "" });

  useEffect(() => {
    const bodyStyle = document.body.style;
    const htmlStyle = document.documentElement.style;

    // Cache original values once
    if (!initialOverflow.current.body && !initialOverflow.current.html) {
      initialOverflow.current = {
        body: bodyStyle.overflow,
        html: htmlStyle.overflow,
      };
    }

    if (menuOpen) {
      bodyStyle.overflow = "hidden";
      htmlStyle.overflow = "hidden";
      bodyStyle.touchAction = "none";
    } else {
      bodyStyle.overflow = initialOverflow.current.body || "";
      htmlStyle.overflow = initialOverflow.current.html || "";
      bodyStyle.touchAction = "";
    }

    return () => {
      bodyStyle.overflow = initialOverflow.current.body || "";
      htmlStyle.overflow = initialOverflow.current.html || "";
      bodyStyle.touchAction = "";
    };
  }, [menuOpen]);

  return (
    <header className={styles.nav}>
      <div className={styles.navAccent} />
      <Brand />

      <nav className={styles.navLinks}>
        {navLinks.map((link) => (
          <a key={link.href} href={link.href} className={styles.navLink}>
            {link.label}
          </a>
        ))}
      </nav>

      <button
        className={`${styles.menuToggle} ${
          menuOpen ? styles.menuToggleOpen : ""
        }`.trim()}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
        onClick={toggleMenu}
      >
        <span />
        <span />
        <span />
      </button>

      <div
        className={`${styles.mobileMenu} ${
          menuOpen ? styles.mobileMenuOpen : ""
        }`.trim()}
      >
        <button
          className={`${styles.closeBtn} ${styles.mobileClose}`}
          onClick={closeMenu}
          aria-label="Close menu"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
        <nav className={styles.mobileNavLinks}>
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} onClick={closeMenu}>
              {link.label}
            </a>
          ))}
        </nav>
      </div>

      {menuOpen ? (
        <div className={styles.menuBackdrop} onClick={closeMenu} />
      ) : null}
    </header>
  );
};

export default NavBar;
